module.exports = {
    blog_title:'Blog do Taption',
    blog_desc:'Artigos úteis e conselhos para criadores. Atualizações de produtos, notícias e informações sobre o Taption.',
    written_by: 'Escrito por', 
}
